import UserNavigationMobile from '@derolfgroep/ui-components/src/components/UserNavigation/UserNavigationMobile'
import UserNavigationDesktop from '@derolfgroep/ui-components/src/components/UserNavigation/UserNavigationDesktop'
import { useUserNavigationItems } from './useUserNavigationItems'
import { useUserProfileInformation } from './useUserProfileInformation'
import { useMediaXsDown } from '@derolfgroep/ui-components/src/hooks/useMediaXsDown'
import { useMemo } from 'react'

const UserNavigation = () => {
  const userNavigationItems = useUserNavigationItems()
  const userProfileInformation = useUserProfileInformation()
  const isXsDown = useMediaXsDown()
  const UserNavigationComponent = useMemo(() => (isXsDown ? UserNavigationMobile : UserNavigationDesktop), [isXsDown])

  return userNavigationItems && userProfileInformation?.fullName ? (
    <UserNavigationComponent user={userProfileInformation} navigationItems={userNavigationItems} />
  ) : null
}

export default UserNavigation
